<script setup lang="ts">
import WidgetRecordAction from '@components/widget/WidgetRecordAction.vue'

import { formatDateHuman } from '@/api/formatter'

const { records, isSelected } = defineProps<{
  records: any[],
  isSelected: Function,
}>()

const emit = defineEmits(['set', 'getRecords', 'select', 'unselect', 'isSelected'])
</script>

<template>
  <VFragment>
    <VTable v-if="records?.length">
      <thead>
        <tr>
          <th>Инн</th>
          <th>ФИО</th>
          <th>Должность</th>
          <th>Пол</th>
          <th>Подразделение</th>
          <th>Принят</th>
          <th class="text-center mw-100">
            Действие
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="record in records"
          :key="record.Uuid"
        >
          <td>{{ record.Inn }}</td>
          <td>
            <RouterLink
              :to="{ name: 'employee', params: { uuid: record.Uuid }, query: { tab: 'preview' } }"
              target="_blank"
            >
              {{ record.Fio }}
            </RouterLink>
          </td>
          <td>{{ record.PositionName }}</td>
          <td>{{ record.SexName }}</td>
          <td>{{ record.DivisionName }}</td>
          <td>{{ formatDateHuman(record.EmploymentDate) || '-' }}</td>
          <td class="text-center">
            <WidgetRecordAction
              :selected="isSelected(record.Uuid)"
              @set="emit('select', record)"
              @delete="emit('unselect', record)"
            />
          </td>
        </tr>
      </tbody>
    </VTable>

    <VListItem v-else>
      Нет данных.
    </VListItem>
  </VFragment>
</template>

<style lang="scss" scoped>
.form-component-bottom {
  display: flex;
  align-items: center;
}

.form-component-bottom__pagination {
  flex-grow: 1;
}
</style>
